export enum OutboundCallState {
  Hidden = 'Hidden',

  Enabled = 'Enabled',

  Disabled = 'Disabled',
}
